<template>
  <iframe
    class="app-container"
    :src="activeApp"
    width="100%"
    height="100%"
    frameborder="0"
    onload="document.getElementById('spinner').style.display='none';"
  >Browser not compatible.</iframe>
</template>

<script>
export default {
  computed: {
    activeApp() {
      //return `${this.$store.state.activeApp}`;
      return `${this.$store.state.activeApp}?token=${this.$store.state.token}`;

    }
  }
};
</script>
<style scoped>
.app-container {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
}
</style>